/** @jsx jsx */
import { useEffect } from 'react'
import { useMapboxContext } from '../useMapboxContext'

const Layer = ({
  layerName,
  children,
  onClick,
  onInit,
  pointer = false,
  visible = false,
}) => {
  if (layerName === undefined || typeof layerName !== 'string')
    throw new Error(
      'The Layer component requires a layerName prop provided as a string',
    )

  const { map } = useMapboxContext()

  useEffect(() => {
    map.current.setLayoutProperty(
      layerName,
      'visibility',
      visible ? 'visible' : 'none',
    )

    const handleClick = onClick ? e => onClick(e, map.current) : undefined

    if (onClick) {
      map.current.on('click', layerName, handleClick)
    }

    return () => {
      if (onClick) map.current.off('click', layerName, handleClick)
      map.current.setLayoutProperty(layerName, 'visibility', 'none')
    }
    // map.current.setLayoutProperty('darkdowntown', 'visibility', 'visible')
  }, [layerName, visible, onClick])

  useEffect(() => {
    if (onInit) onInit(map.current)
  }, [])

  useEffect(() => {
    const onEnter = () => {
      map.current.getCanvas().style.cursor = 'pointer'
    }
    const onLeave = () => {
      map.current.getCanvas().style.cursor = ''
    }
    if (pointer) {
      map.current.on('mouseenter', layerName, onEnter)
      map.current.on('mouseleave', layerName, onLeave)
    }
    return () => {
      map.current.off('mouseenter', layerName, onEnter)
      map.current.off('mouseleave', layerName, onLeave)
      map.current.getCanvas().style.cursor = ''
    }
  }, [pointer])

  return children || null
}

export { Layer }
